import React, { useCallback } from "react";
import Modal from "../../Modal/Modal";
import ViewContent from "../../../../containers/manage/CreateShotClass/ViewContent/ViewContent";

const ClassCardContentModal = React.memo(
  ({ contentVideoModal, setContentVideoModal, shotClassData }) => {
    // Memoize the toggle function to prevent unnecessary re-renders
    const toggleModal = useCallback(() => {
      setContentVideoModal(false);
    }, [setContentVideoModal]);
    return (
      <Modal
        isOpen={contentVideoModal}
        toggle={toggleModal}
        width={"100"}
        heading={"Details"}
      >
        <ViewContent shotclassData={shotClassData} />
      </Modal>
    );
  }
);

export default ClassCardContentModal;
